<template>
  <div class="animated fadeIn">
    <b-row class="mb-4">
      <b-col lg="12">
        <b-form-group>
          <CoolSelect
            v-model="territoryID"
            class="form-input dropdown-content"
            placeholder="Territory"
            theme="bootstrap"
            tooltip="Territory"
            :items="territory.territories"
            item-text="TerritoryName"
            item-value="TerritoryID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Territory</b-input-group-text>
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
            class="primary-row divider-row"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!showYear"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showYear = !showYear"
                ></i>
                <i
                  v-if="showYear"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showYear = !showYear"
                ></i>
                <h4 class="display-4 drtext">By Year</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <!-- <h4 class="display-4 drtext-small">Total Quantity: {{ZipTotal}}</h4> -->
            </b-col>
            <b-col md="1" >
              <!-- <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i> 
                </span>-->
            </b-col>
          </b-row>
           <b-row class="mt-3"></b-row>
            <b-row v-if="showYear">
      <b-col sm="12">
        <b-table
          :items="territory.analysis_years"
          :fields="fieldsYear"
          hover
          small
          fixed
          caption
          responsive="sm"
        >
        </b-table>
       
      </b-col>
    </b-row>
    <b-row class="mt-3"></b-row>
    <b-row
            class="primary2-row divider-row"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!showMonth"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showMonth = !showMonth"
                ></i>
                <i
                  v-if="showMonth"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showMonth = !showMonth"
                ></i>
                <h4 class="display-4 drtext">By Month</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <!-- <h4 class="display-4 drtext-small">Total Quantity: {{ZipTotal}}</h4> -->
            </b-col>
            <b-col md="1" >
              <!-- <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i> 
                </span>-->
            </b-col>
          </b-row>
           <b-row class="mt-3"></b-row>
            <b-row v-if="showMonth">
      <b-col sm="12">
        <b-table
          :items="territory.analysis_months"
          :fields="fieldsMonth"
          hover
          small
          fixed
          caption
          responsive="sm"
        >
        </b-table>
       
      </b-col>
    </b-row>
    <b-row class="mt-3"></b-row>
    <b-row
            class="primary3-row divider-row"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!showDOW"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showDOW = !showDOW"
                ></i>
                <i
                  v-if="showDOW"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showDOW = !showDOW"
                ></i>
                <h4 class="display-4 drtext">By Day of Week</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <!-- <h4 class="display-4 drtext-small">Total Quantity: {{ZipTotal}}</h4> -->
            </b-col>
            <b-col md="1" >
              <!-- <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i> 
                </span>-->
            </b-col>
          </b-row>
           <b-row class="mt-3"></b-row>
            <b-row v-if="showDOW">
      <b-col sm="12">
        <b-table
          :items="territory.analysis_dows"
          :fields="fieldsDOW"
          hover
          small
          fixed
          caption
          responsive="sm"
        >
        </b-table>
       
      </b-col>
    </b-row>
    <b-row class="mt-3"></b-row>
    <b-row
            class="primary4-row divider-row"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!showRestaurant"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showRestaurant = !showRestaurant"
                ></i>
                <i
                  v-if="showRestaurant"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showRestaurant = !showRestaurant"
                ></i>
                <h4 class="display-4 drtext">By Restaurant</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <!-- <h4 class="display-4 drtext-small">Total Quantity: {{ZipTotal}}</h4> -->
            </b-col>
            <b-col md="1" >
              <!-- <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i> 
                </span>-->
            </b-col>
          </b-row>
           <b-row class="mt-3"></b-row>
            <b-row v-if="showRestaurant">
      <b-col sm="12">
        <b-table
          :items="territory.analysis_rests"
          :fields="fieldsRest"
          hover
          small
          fixed
          caption
          responsive="sm"
        >
        </b-table>
       
      </b-col>
    </b-row>
        <b-row class="mt-3"></b-row>
    <b-row
            class="primary5-row divider-row"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!showArtwork"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showArtwork = !showArtwork"
                ></i>
                <i
                  v-if="showArtwork"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="showArtwork = !showArtwork"
                ></i>
                <h4 class="display-4 drtext">By Artwork</h4>
              </span>
            </b-col>
            <b-col md="3" style="float: right">
              <!-- <h4 class="display-4 drtext-small">Total Quantity: {{ZipTotal}}</h4> -->
            </b-col>
            <b-col md="1" >
              <!-- <span class="icon-small">
               <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;" 
                  @click="my_download"
                ></i> 
                </span>-->
            </b-col>
          </b-row>
           <b-row class="mt-3"></b-row>
            <b-row v-if="showArtwork">
      <b-col sm="12">
        <b-table
          :items="territory.analysis_artworks"
          :fields="fieldsArtwork"
          hover
          small
          fixed
          caption
          responsive="sm"
        >
        </b-table>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"; 
import { CoolSelect } from "vue-cool-select";
import cTable from "@/views/base/Table.vue";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "dashboard",
  components: {
    CoolSelect,
    cTable,
    datepicker
  },
  data: () => {
    return {
      territoryID: -1,
      showYear: false,
      showMonth: false,
      showDOW: false,
      showRestaurant: false,
      showArtwork: false,
      reportMonth: "",
      reportYear: new Date().getFullYear().toString(),
      searchString: "",
      vwReport: "WeeklyTracker",
      reportHasDateFilters: true,
      reportHasYYMMFilters: false,
      reportHasPPFilters: true,
      reportHasSearch: true,
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
        // ,
        // minDate: new Date()
        // ,
        // daysOfWeekDisabled: [0, 6]
      },
      fieldsYear: [
        {
          key: "Year",
          label: "Year",
          sortable: true
        },
         {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Attendees",
          label: "Attendees",
          sortable: true
        },
        { key: "Wait", label: "Wait", sortable: true },
        { key: "Web", label: "Web", sortable: true },
        { key: "sRSVP", label: "RSVP", sortable: true },
        { key: "sRSVPNoWeb", label: "RSVP No Web", sortable: true },
        
      ],
      fieldsMonth: [
        {
          key: "Month",
          label: "Month",
          sortable: true
        },
         {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Attendees",
          label: "Attendees",
          sortable: true
        },
        { key: "Wait", label: "Wait", sortable: true },
        { key: "Web", label: "Web", sortable: true },
         { key: "sRSVP", label: "RSVP", sortable: true },
        { key: "sRSVPNoWeb", label: "RSVP No Web", sortable: true },
        
      ],
      fieldsDOW: [
        {
          key: "DOW",
          label: "Day",
          sortable: true
        },
         {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Attendees",
          label: "Attendees",
          sortable: true
        },
        { key: "Wait", label: "Wait", sortable: true },
        { key: "Web", label: "Web", sortable: true },
         { key: "sRSVP", label: "RSVP", sortable: true },
        { key: "sRSVPNoWeb", label: "RSVP No Web", sortable: true },
        
      ],
      fieldsRest: [
        {
          key: "Restaurant.Name",
          label: "Restaurant",
          sortable: true
        },
         {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Attendees",
          label: "Attendees",
          sortable: true
        },
        { key: "Wait", label: "Wait", sortable: true },
        { key: "Web", label: "Web", sortable: true },
         { key: "sRSVP", label: "RSVP", sortable: true },
        { key: "sRSVPNoWeb", label: "RSVP No Web", sortable: true },
        
      ],
      fieldsArtwork: [
        {
          key: "Artwork.ArtworkName",
          label: "Artwork",
          sortable: true
        },
         {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "Attendees",
          label: "Attendees",
          sortable: true
        },
        { key: "Wait", label: "Wait", sortable: true },
        { key: "Web", label: "Web", sortable: true },
         { key: "sRSVP", label: "RSVP", sortable: true },
        { key: "sRSVPNoWeb", label: "RSVP No Web", sortable: true },
        
      ],
    };
  },
  watch: {
    "territoryID": function (newValue) {
      this.LoadReports();
    },
  },
  created() {
    
    if (this.$store.state.territory.territory_edit)
    {
      this.territoryID = this.$store.state.territory.territory_edit.TerritoryID;
    }
  },
  computed: {
    ...mapState(["globals", "territory", "n_user"])
  },
  methods: {
    async LoadReports()
    {
      await this.$store.dispatch("territory/GetAnalysisByYear", this.territoryID);
      await this.$store.dispatch("territory/GetAnalysisByMonth", this.territoryID);
      await this.$store.dispatch("territory/GetAnalysisByDOW", this.territoryID);
      await this.$store.dispatch("territory/GetAnalysisByRest", this.territoryID);
      await this.$store.dispatch("territory/GetAnalysisByArtwork", this.territoryID);

    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.icon-small {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
